import $ from 'jquery';
import urlparams from '../utility/urlparams';

const $nav = $('.navigation');
const $body = $('html');
const $navToggle = $('.js-navigation-toggle');
const $navSubmenuToggle = $('#navigation-submenu-toggle');
let menuOpen = false;
let submenuOpen = false;

const navLinksMinHeight = 50;
const navLinksMaxHeight = 80;
const $navLinksLvlWrap = $nav.find('> ul');
const $navLinksLvlOne = $nav.find('> ul > li');
const navLinksLvlOneCount = $navLinksLvlOne.length;

const windowHeight = 0;

function init() {
    if ($nav.length < 1) return;

    addMobileClickHandlers();
    checkLinksHeight();
    $(window).on('resize', checkLinksHeight);
    urlDeeplinkCheck();
}


function checkLinksHeight() {
    const win = $(window);
    const navigationMideaQueryCheck = ($navLinksLvlWrap.css('top').replace('px', '') > 0);

    if (windowHeight !== win.height() && navigationMideaQueryCheck) {
        const containerHeight = $navLinksLvlWrap.height() - navLinksLvlOneCount;
        const linkHeight = Math.floor(containerHeight / navLinksLvlOneCount);
        setNavLinksHeight(linkHeight);
    } else {
        if (!navigationMideaQueryCheck) {
            clearNavLinksHeight();
        }
    }
}

function setNavLinksHeight(value) {
    let val = value;


    if (value >= navLinksMaxHeight) {
        val = navLinksMaxHeight;
    }
    if (value <= navLinksMinHeight) {
        val = navLinksMinHeight;
        $navLinksLvlWrap.attr('style', '');
    } else {
        $navLinksLvlWrap.css({'overflow': 'visible'});
        // changed to visible after z-index was added.
    }


    const amount = val + 'px';

    $navLinksLvlOne.each(function (i, el) {
        const $li = $(el);
        const $link = $($li.find('> .navigation__list__item__link'));
        const $icon = $($link.find('> .icon'));
        const $svg = $($icon.find('svg'));

        $li.css({'height': amount});
        $link.css({'height': amount, 'line-height': amount});
        $icon.css({'height': amount});

        if (value <= 50) {
            const amountMin = (val * 0.75) + 'px';
            $svg.css({'height': amountMin});
        } else {
            $svg.attr('style', '');
        }

    });
}

function clearNavLinksHeight() {
    $navLinksLvlOne.each(function (i, el) {
        const $li = $(el);
        const $link = $($li.find('> .navigation__list__item__link'));
        const $icon = $($link.find('> .icon'));
        const $svg = $($icon.find('svg'));
        $li.attr('style', '');
        $link.attr('style', '');
        $icon.attr('style', '');
        $svg.attr('style', '');
        $navLinksLvlWrap.attr('style', '');
    });
}

function addMobileClickHandlers() {

    $navToggle.on('click', clickToggleMenu);
    $navSubmenuToggle.on('click', closeSubmenu);
    const mainLinks = $nav.find(' ul  > li > .navigation__list__item__link');

    mainLinks.each(function (i, el) {
        const $link = $(el);
        const $submenu = $link.siblings('.navigation-submenu');

        $link.on('click', function (e) {
            checkForSubmenu(e, $submenu);
        });
    });
}

function checkForSubmenu(e, $submenu) {

    const submenu = $submenu;
    if (submenu.length > 0) {
        e.preventDefault();
        toggleSubmenu(submenu);
    }
}

function clickToggleMenu(e) {
    e.preventDefault();
    toggleMenu();
}

function toggleMenu() {
    if ($body.hasClass('nav-is-open')) {
        closeMenu();
    } else {
        openMenu();
    }
}

function closeMenu() {
    $body.removeClass('nav-is-open');
    menuOpen = false;
    removeClickCloseToDocument();
    closeSubmenu();
}

function openMenu() {
    $body.addClass('nav-is-open');

    menuOpen = true;
    addClickCloseToDocument();
}

function toggleSubmenu(submenu) {
    if (!submenu.hasClass('is-open')) {
        openSubmenu(submenu);

    } else {
        closeSubmenu();
    }
}

function addClickCloseToDocument() {
    $('.main-content').one('click', closeMenu);
    $nav.one('click', function (e) {
        e.stopPropagation();
    });

}

function removeClickCloseToDocument() {
    $('.main-content').off('click');
    $nav.off('click');

}

function openSubmenu(submenu) {

    if (submenuOpen){
        closeSubmenu();
    }
    openMenu();
    $nav.addClass('has-open-submenu');
    submenu.addClass('is-open');
    submenu.parent('li').addClass('has-open-submenu');


    $body.addClass('nav-submenu-is-open');
    submenuOpen = true;
}

function closeSubmenu() {
    $('.navigation-submenu.is-open').removeClass('is-open');
    $('li.has-open-submenu').removeClass('has-open-submenu');
    $nav.removeClass('has-open-submenu');
    $body.removeClass('nav-submenu-is-open');
    submenuOpen = false;
}

function urlDeeplinkCheck(){
    const submenuParam = urlparams.getParameterByName('sm');
    if (submenuParam){
        // console.log(submenuParam);
        const submenu = $($nav.find('a[data-href="/' + submenuParam + '"] ~ .navigation-submenu'));
        if (submenu.length > 0){
            openSubmenu(submenu);
        }
    }
}

export default {
    init
};
